import * as yup from 'yup';

import { ObjectTypeBase } from '../../../baseTypes/ObjectTypeBase';
import { PropertiesInterface } from '../../../properties/Property';
import { AllTypeContexts } from '../../../properties/TypeContextEnum';

import { Types } from '../../../properties/Types';
import { EmailDefinition } from '../../../properties/baseTypes/Email';
import { PhoneNumberDefinition } from '../../../properties/baseTypes/PhoneNumber';
import { uuidTypeDefinition } from '../../../properties/baseTypes/UUID';
import { TYPE_GROUP_INTEGRATION } from '../../../properties/constants';
import { createShapeFromProperties } from '../../../properties/createShapeFromProperties';

const properties: PropertiesInterface = {
  id: {
    friendlyName: 'ID',
    type: 'String',
  },
  first_name: {
    friendlyName: 'First Name',
    type: 'String',
    validators: [
      {
        name: 'Required',
        value: true,
      },
    ],
  },
  last_name: {
    friendlyName: 'Last Name',
    type: 'String',
    validators: [
      {
        name: 'Required',
        value: true,
      },
    ],
  },
  email: {
    friendlyName: 'Visitor Email',
    type: 'Email',
  },
  phone: {
    friendlyName: 'Visitor Phone',
    type: 'PhoneNumber',
  },
};

const shape = createShapeFromProperties(properties);
const schema = yup
  .object()
  .shape(createShapeFromProperties(properties))
  .nullable();

interface Visitor {
  id?: string;
  firstName: string;
  lastName: string;
  email?: string;
  number?: string;
}

export class BEVisitorType extends ObjectTypeBase {
  group = TYPE_GROUP_INTEGRATION;

  name = 'BEVisitor';

  friendlyName = 'Building Prism Visitor';

  superUserOnly = true;

  contexts = AllTypeContexts;

  get example() {
    return {
      id: uuidTypeDefinition.example,
      firstName: 'Lane',
      lastName: 'Doe',
      email: EmailDefinition.example,
      number: PhoneNumberDefinition.example,
    };
  }

  get default(): Visitor {
    return {
      id: '',
      firstName: '',
      lastName: '',
      email: '',
      number: '',
    };
  }

  shape = shape;

  buildSchema() {
    return schema;
  }

  properties = properties;
}

const definition = new BEVisitorType();

Types.addType(definition as any);

export { definition };
